module.exports = __webpack_public_path__ + "static/media/landskronavapen.b88f2afc.png";